import { LogOut, Sparkles } from "lucide-react";
import { Link } from "react-router-dom";
import { BrandMark } from "@/brand/BrandMark";

/**
 * Mobile-first shell dedicado às colaboradoras da limpeza.
 * Não expõe navegação para telas administrativas.
 */
export function CleaningShell({ user, onLogout, children, subtitle = "Painel da Limpeza" }) {
  return (
    <div className="min-h-screen bg-[#F5F1E8] flex flex-col">
      <header className="sticky top-0 z-30 bg-[#FFFFFF] border-b border-stone-200 px-4 py-3">
        <div className="max-w-3xl mx-auto flex items-center justify-between gap-3">
          <Link to="/limpeza" className="flex items-center gap-3 min-w-0" data-testid="cleaning-header-home">
            <div className="w-10 h-10 rounded-md bg-[#083A6B] flex items-center justify-center text-[#F5F1E8] shrink-0">
              <Sparkles size={18} strokeWidth={1.6} />
            </div>
            <div className="min-w-0">
              <div className="font-brand-title text-base text-[#083A6B] font-bold leading-none truncate">Rede Hospeda</div>
              <div className="text-[10px] uppercase tracking-[0.2em] text-stone-500 mt-1 truncate">{subtitle}</div>
            </div>
          </Link>
          <div className="flex items-center gap-2 shrink-0">
            {user?.name && (
              <span className="hidden sm:inline text-xs text-stone-500 truncate max-w-[160px]">{user.name}</span>
            )}
            <button
              onClick={onLogout}
              data-testid="btn-cleaning-logout"
              className="w-10 h-10 rounded-md border border-stone-200 flex items-center justify-center text-stone-600 hover:text-[#D4A652] hover:border-[#D4A652] transition-colors"
              aria-label="Sair"
            >
              <LogOut size={18} />
            </button>
          </div>
        </div>
      </header>
      <main className="flex-1 px-4 py-5 pb-24">
        <div className="max-w-3xl mx-auto">{children}</div>
      </main>
      <footer className="border-t border-stone-200 bg-[#FFFFFF] py-3 text-center text-[11px] text-stone-500">
        <div className="flex items-center justify-center gap-1.5">
          <BrandMark variant="mark" size={14} /> Rede Hospeda · Área restrita
        </div>
      </footer>
    </div>
  );
}
